import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FAST_ANIMATION_DURATION_MS } from "app/modules/project-from-comparison/config";

const { carbon, red } = colorsPalettes;

export const AnimatedWrapper = styled.div<{ $height: string }>`
    overflow: hidden;
    height: ${(p) => p.$height};
    transition: height ${FAST_ANIMATION_DURATION_MS}ms ease;
`;

export const Container = styled.div`
    ${setFontVariant("body2", carbon[400])};
    box-sizing: border-box;
    padding: 16px;

    background-color: ${red[100]};

    border-radius: 3px;
    border: 1px solid ${red[300]};
`;
